(function(w){
'use strict';
const configNode=document.querySelector('[data-rc-search-config]');
if(!configNode)return;
const config=JSON.parse(configNode.textContent),wordCache=new WeakMap();
let catalogPromise,loadedAt=0;
function norm(value){
 return String(value||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ß/g,'ss')
  .replace(/\bsimpson\b/g,'simson').replace(/\bherkules\b/g,'hercules').replace(/\bzuendapp\b/g,'zundapp')
  .replace(/\b(?:vw|volkswagen)\b/g,'volkswagen').replace(/\b(?:piaggio|vespa)\b/g,'piaggio')
  .replace(/\bmercedes[\s-]+benz\b/g,'mercedes').replace(/\bar[ck]ona[\s-]*sand\b/g,'arconasand')
  .replace(/\b(?:spray|lackspray|spraydosen)\b/g,'spraydose').replace(/\bmet\b/g,'metallic')
  .replace(/(\d)[-–](?=\d)/g,'$1')
  .replace(/\b(l|la|lb|lc|ld|le|lg|lx|ly|lz)[\s-]+(?=[a-z]?\d)/g,'$1')
  .replace(/\b(l[a-z]?\d{2,4})[\s-]+([a-z])\b/g,'$1$2')
  .replace(/\bral\s*(?=\d)/g,'ral ')
  .replace(/\b(\d+)\s*(ml|liter)\b/g,'$1 $2')
  .replace(/ae/g,'a').replace(/oe/g,'o').replace(/ue/g,'u')
  .replace(/\b(?:variante|v)[.\s]*(\d+[a-z]?)/g,'v$1');
}
function words(value){
 return norm(value).replace(/\b(sra|sr|kr|sd|sl|s|ks|k|gts|cs|zd|zf|mp|mk|ms|mv|vs|ds|vz|mch|ax|tf|etz|ets|es|ts|rt|bk|sm|rlw|rl|comet|foxi|hobby|pony|ponny)\s*(\d+)([a-z]*)\b/g,'$1 $2 $3').match(/[a-z0-9]+/g)||[];
}
function searchable(p){
 if(wordCache.has(p))return wordCache.get(p);
 const title=words(p.title),source=[p.title,p.vendor||'',...(p.tags||[]),...(p.variants||[])].join(' ');
 const data={title,all:words(source),colours:words(source.replace(/\b\d+(?:[.,]\d+)?\s*(?:ml|liter)\b/gi,' '))};wordCache.set(p,data);return data;
}
function termMatches(word,term){
 if(word===term)return true;
 if(/^\d+$/.test(term))return /^l\d+$/.test(word)&&word.slice(1)===term;
 return !/\d/.test(term)&&term.length>=4&&word.includes(term);
}
function matches(p,q){
 const need=Array.isArray(q)?q:words(q),data=searchable(p);
 return need.length>0&&need.every((term,index)=>{
  const quantity=/^\d+$/.test(term)&&/^(?:ml|liter)$/.test(need[index+1]||'');
  const source=/\d/.test(term)&&!quantity?data.colours:data.all;
  return source.some(word=>termMatches(word,term));
 });
}
function url(path){
 const u=new URL((config.root||'/').replace(/\/$/,'')+path,location.origin);
 const preview=new URLSearchParams(location.search).get('preview_theme_id');
 if(preview)u.searchParams.set('preview_theme_id',preview);
 return u;
}
async function request(u){
 const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),12000);
 try{const r=await fetch(u,{credentials:'same-origin',signal:controller.signal});if(!r.ok)throw Error('Search unavailable');return await r.json();}
 finally{clearTimeout(timer);}
}
async function catalogPage(page){
 const u=url('/collections/all');u.searchParams.set('view','rc-search-index');u.searchParams.set('page',String(page));u.searchParams.set('sort_by','title-ascending');
 let data;
 try{data=await request(u);}catch(e){data=await request(u);}
 if(data.version!==2||!Array.isArray(data.products)||data.page!==page||!Number.isInteger(data.total)||data.total<0||!Number.isInteger(data.pages)||data.pages<0||data.pages>100||(data.total>0&&data.pages<1))throw Error('Invalid catalog');
 return data;
}
function catalog(){
 if(catalogPromise&&Date.now()-loadedAt<120000)return catalogPromise;
 loadedAt=Date.now();
 catalogPromise=(async()=>{
  const first=await catalogPage(1),parts=[first];let next=2;
  await Promise.all(Array.from({length:Math.min(4,Math.max(0,first.pages-1))},async()=>{while(next<=first.pages){const page=next++;const data=await catalogPage(page);if(data.total!==first.total||data.pages!==first.pages)throw Error('Catalog changed');parts.push(data);}}));
  const byID=new Map();parts.sort((a,b)=>a.page-b.page).forEach(part=>part.products.forEach(p=>{
   if(!p||typeof p.title!=='string'||typeof p.url!=='string'||!p.id)return;
   const u=new URL(p.url,location.origin);if(u.origin===location.origin&&/^\/(?:[a-z]{2}(?:-[a-zA-Z]{2})?\/)?products\/[a-z0-9-]+$/.test(u.pathname))byID.set(p.id,{...p,url:u.pathname});
  }));
  if(byID.size!==first.total)throw Error('Incomplete catalog');
  return [...byID.values()];
 })().catch(e=>{catalogPromise=null;throw e;});
 return catalogPromise;
}
function articleNumber(q){
 const match=String(q||'').trim().match(/^rc\s*[-–—]?\s*(\d{5})$/i);
 return match?'RC-'+match[1]:'';
}
async function findArticle(number){
 let result;
 for(const product of await catalog()){
  for(const [code,id,title,available] of product.articleNumbers||[]){
   if(code!==number||!/^\d+$/.test(String(id)))continue;
   if(result)return [];
   const link=new URL(product.url,location.origin);
   link.searchParams.set('variant',String(id));
   const preview=new URLSearchParams(location.search).get('preview_theme_id');
   if(preview)link.searchParams.set('preview_theme_id',preview);
   result={...product,url:link.pathname+link.search,articleNumber:code,variantTitle:title,available};
  }
 }
 return result?[result]:[];
}
async function search(q){
 const number=articleNumber(q);
 if(number)return findArticle(number);
 const need=words(String(q||'').trim().slice(0,100));if(!need.length)return [];
 const all=await catalog();
 const score=p=>need.reduce((n,t)=>n+(searchable(p).title.includes(t)?4:searchable(p).title.some(x=>termMatches(x,t))?2:0),0);
 return all.filter(p=>matches(p,need)).sort((a,b)=>score(b)-score(a)||a.title.localeCompare(b.title,'de'));
}
function node(tag,text,cls){const n=document.createElement(tag);if(text)n.textContent=text;if(cls)n.className=cls;return n;}
function display(container,data,mode){
 container.replaceChildren();let shown=0;
 const home=mode==='home',shop=mode==='shop',more=node('button',config.more,home?'rc-home-button':'rcfh-button');more.type='button';
 const holder=home?node('li'):more;if(home)holder.append(more);
 function append(){
  data.slice(shown,shown+20).forEach(p=>{
   const link=node('a',null,home?'rc-home-product':shop?'link underlined-link':'rcfh-button rcfh-product');link.href=p.url;link.append(node('strong',p.title));
   if(p.articleNumber){
    const detail=[p.variantTitle==='Default Title'?'':p.variantTitle,p.articleNumber].filter(Boolean).join(' · ');
    link.append(shop?node('br'):document.createTextNode(' '),node('span',detail));
    if(shop)link.append(node('br'));
   }
   link.append(node('span',config.open+' →'));
   if(home){const item=node('li');item.append(link);if(p.available===false&&config.unavailable)item.append(node('small',config.unavailable));container.insertBefore(item,holder);}
   else container.insertBefore(link,holder);
  });
  shown=Math.min(shown+20,data.length);holder.hidden=shown>=data.length;
 }
 more.addEventListener('click',append);container.append(holder);append();
}
function summary(count){return config.count.replace('{count}',String(count));}
function parseQuery(value){
 const raw=String(value||'').trim().slice(0,100),clean=norm(raw);
 const colour=/\b(?:farbe|farbton|farbtoene|farbtone|farbcode|farbnummer|lackcode|lacknummer)\b/.test(clean);
 const model=/\b(?:modell|modelle|modellnummer|fahrzeugmodell|typ)\b/.test(clean);
 const query=raw.replace(/\b(?:farbe|farbton|farbtöne|farbtoene|farbcode|farbnummer|lackcode|lacknummer|modell|modelle|modellnummer|fahrzeugmodell|typ)\b/gi,' ').replace(/\bherkules\b/gi,'Hercules').replace(/\s+/g,' ').trim();
 return {query,intent:colour&&!model?'colour':model&&!colour?'model':'auto'};
}
function isCodeQuery(value){return /^[a-z]{0,3}\d{1,5}[a-z]?(?:\/[a-z0-9]{1,5})?$/.test(norm(value).replace(/\s+/g,''));}
function titleMatches(product,query){const need=words(query),title=searchable(product).title;return need.length>0&&need.every(term=>title.some(word=>termMatches(word,term)));}
function colourCodes(product){
 const label=norm(product.title.split(/[–|]/)[0]).replace(/\b\d+(?:[.,]\d+)?\s*(?:ml|liter|kg|gramm)\b/g,' ');
 const colourPart=label.split(/\b(?:typ|modell|mod)\b|\bv[.\s]*\d/)[0];
 const first=colourPart.match(/\b[a-z]{0,3}\d{1,5}[a-z]?(?:\/[a-z0-9]{1,5})?\b/),codes=first?[first[0]]:[];
 for(const alias of label.matchAll(/\((?:auch|alias|alternativ)\s+([^)]*)\)/g))codes.push(...(alias[1].match(/\b[a-z]{0,3}\d{1,5}[a-z]?(?:\/[a-z0-9]{1,5})?\b/g)||[]));
 return [...new Set(codes)];
}
function codeMatches(product,query){
 if(!isCodeQuery(query))return false;
 const comparable=code=>/^l\d+$/.test(code)?code.slice(1):code,need=comparable(norm(query).replace(/\s+/g,''));
 return colourCodes(product).some(code=>comparable(code)===need);
}
async function directColours(brands,query){
 const all=await catalog(),patterns=brands.map(brand=>new RegExp(brand.pattern,'i'));
 return all.filter(product=>patterns.some(pattern=>pattern.test(norm(product.title)))&&codeMatches(product,query)).sort((a,b)=>a.title.localeCompare(b.title,'de'));
}
w.RCProductSearch={search,articleNumber,matches,norm,words,catalog,display,summary,url,config,parseQuery,isCodeQuery,titleMatches,colourCodes,codeMatches,directColours,version:3};
const shopResult=document.querySelector('[data-rc-article-search]');
const shopNumber=articleNumber(shopResult?.dataset.query);
if(shopNumber){
 const status=shopResult.querySelector('[role="status"]');
 const results=shopResult.querySelector('[data-rc-article-results]');
 document.querySelectorAll('[data-rc-native-search]').forEach(el=>{el.hidden=true;});
 shopResult.hidden=false;
 findArticle(shopNumber).then(data=>{
  status.textContent=data.length?'':config.article_none;
  if(data.length)display(results,data,'shop');
 }).catch(()=>{status.textContent=config.article_failed;});
}
})(window);
